import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { _datarender_virbom_from_single_virtel, _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey } from "./ter-virbom-datarender";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from "./virtel-consts";
import tclocal from "./ter-consts-local-lib";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$_bundle_limcustom = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_limcustom.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_limcustom',
    // terkknivo: null, // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno
    //
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_limcustom.default_subform_item_preset_state = () => {
  const preset_state = {
    // tempkey: //
    identmaterijala: null,
    termaterijal: null,
    naziv: null,
    sirina: null,
    duzina: null,
    povrsina: -1, // da ne bi proslo validaciju po defaultu
    kolicina: null,
    operacija1: "OPSEC",
    rc1: "",
    operacija2: "",
    rc2: "",
    cnccrtez: null,
    naziv_materijala: null, // NOVO
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_limcustom.keys_for_direct_cloning = [
  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_limcustom.default_subform_item_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$_bundle_limcustom');
  // console.log(formState);
  let state = {
    ...formState
  };
  const state2 = {
    virtelschemakey: 'terkk$limcustom',
    ...state,
    // flag_paired_with_smartel: false, // ovaj virtel direktno uparen sa smartel.subkey
    ..._get_fixed_fields(sema),
    virtelclass: "terkk$limcustom",
    ..._getParamsFromLib("terkk$limcustom") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


//////////


draftel_codecs_pack_terkk$_bundle_limcustom.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda

    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(limcustom_raw => {
      let draftel_limcustom = {
        ...draftel_codecs_pack_terkk$_bundle_limcustom.default_preset_state(),
        ...limcustom_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(draftel_limcustom);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_limcustom.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$_bundle_eliminatorkapi');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // _bundle_eliminatorkapi (nema semu), ne salje se na backned, nema use_genus ni slicno... od njega ovde sad izracunavamo eliminatorkapi koji ce imati sve te parametre.
  // bundle_id sluzi da grupise nekoliko itema da idu zajedno
  // NOVO....POCETAK
  // rastavljamo bundle na pojedinacne p pomocu codec-a
  let unbundled_arr = draftel_codecs_pack_terkk$_bundle_limcustom.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);
  console.log('bundle Arr spakovano sledece ');
  console.log(unbundled_arr);
  // Sad prodjem kroz unbundleovani array i spakujem svaki kao ostale poluproizvode
  unbundled_arr.forEach((_p, index) => {
    let p = _p;
    // KORAK poluproizvod level 3 virtel
    // novonastali elementi raspakovani iz bundlea i oni jos uvek nemaju svoje ID-ove. Sada je potrebno da im dodelimo ID pomocu _enrichWithFreshSubkey()
    // graphlevel: 3,
    let local_graphlevel = 1;
    let x; // JOCKER
    let xm; // JOCKER
    if (p.operacija2 && typeof p.operacija2 === 'string' && p.operacija2 !== '') {
      // dve operacije
      // druga od dve
      const p2 = {
        ..._p,
        "terkategorija": "PP",
        "tergrupa": "LIM",
        jm: tclocal.JM_KOM,
        termaterijal: _p.identmaterijala, // ident materijala ide u secenje
        operacija: _p.operacija2, // operacija 2
        rc: _p.rc2, // rc 2
      };
      let virtel_op2 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
        ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p2),
      });
      _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_op2, local_graphlevel);
      // prva od dve
      const p1 = {
        ..._p,
        "terkategorija": "PP",
        "tergrupa": "LIM",
        kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
        jm: tclocal.JM_KOM,
        termaterijal: _p.identmaterijala, // ident materijala ne ide kad nije secenje ali privremeno neka ostane
        operacija: _p.operacija1, // operacija 1
        rc: _p.rc1, // rc 1
        // derivat nema operaciju 1 i 2 nego samo prostu operaciju
        operacija1: null, // operacija 1
        rc1: null, // rc 1
        operacija2: null, // operacija 2
        rc2: null, // rc 2
        virtelschemakey: 'terkk$limcustom$derivat1',
      };
      x = p2;
      let virtel_op1 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
        ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p1),
        virtelschemakey: 'terkk$limcustom$derivat1', // da bi bio autocreated on mora da koristi semu derivata koja se razlikuje samo po tome sto je za nju ukljuceno autocreate
      });
      _virbom_manipulator.add_as_last_virtel_children(virbom_ref, virtel_op1);
    } else {
      // 1 operacija
      const p1 = {
        ..._p,
        "terkategorija": "PP",
        "tergrupa": "LIM",
        jm: tclocal.JM_KOM,
        termaterijal: _p.identmaterijala,
        operacija: _p.operacija1, // operacija 1
        rc: _p.rc1, // rc 1
      };
      x = p1;
      let virtel_op1 = _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey({
        ...draftel_codecs_pack_terkk$_bundle_limcustom.subDrafel_to_virtel(p1),
      });
      _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_op1, local_graphlevel);

    }
    // zatim dodavanje njegovog materijala
    let naziv_materijala = "?";
    if (typeof x.naziv_materijala === 'string') {
      naziv_materijala = x.naziv_materijala;
    }
    xm = {
      // ...x,
      // virtelschemakey: "terkk$kadica$materijal1",
      virtelschemakey: "terkk$limcustom$materijal1",
      // "virtelclass": "terkk$kadica$materijal_lim",
      // "virtelclass": "terkk$kadica$materijal_lim",
      "terkategorija": "M",
      // "tergrupa": "LIM", // ne treba grupa za materijal
      // "ident": x.ident,
      // calculated_ident: x.ident,
      identmaterijala: x.identmaterijala,
      ident: x.identmaterijala,
      calculated_ident: x.identmaterijala,
      // "ident": x.ident,
      // identcustom: x.identmaterijala,
      // "naziv": "?",
      "naziv": naziv_materijala,
      // "tip": "", // TODO ???
      // "jm": "m2",
      "jm": tclocal.JM_M2,
      kolicina: x.povrsina,
      // virtelclass: "terkk$_grupa_lim.1_materijal",
    }
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey(xm)); // NAPOMENA: moramo da mu dodamo subkey jer ga ovde kreiramo automatski a nigde nismo izvršili merge i on do sada nije imao subkey.



    // zatim preuzimamo taj novi ID da bi children elementi koji slede imali za parent_subkey.
    // console.log(virtel_elk);
    // const local_graphlevel = 1;
    // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_demper, 3);
    // _virbom_manipulator.add_as_first_virtel(virbom_ref, virtel);

    // KORAK pripreme derivata za
    /*
    let pods_input_za_derivate = derAutoCreateVirbom_terkk_eliminatorkapi_prepare_vir_input(p);
    let _derivati = derAutoCreateVirbom_terkk_eliminatorkapi_children(pods_input_za_derivate);
    console.log('_derivati eliminatorkapi');
    console.log(_derivati);
    // USISAVANJE
    _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);
    */

    // ***ZAVRSENI KORACI ZA JEDAN pp3

  }); // end of eliminatorKapiArr foreach

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_limcustom.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_limcustom.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_limcustom.keys_for_direct_cloning)
  };
  //
  return state;
};


draftel_codecs_pack_terkk$_bundle_limcustom._virtelArr_to_bundleDraftel = (_virtelArr, _generate_fresh_subkey, _generateFreshTempkey) => {
  // TO FORM
  // virtel elk arr to single draftel _bundle_eliminatorkapi
  // _bundle_eliminatorkapi ne treba bundle_id jer svi elk. od jednog projekta koji pripadaju jednom modulu su uvek jedan bundle. Dakle za bundlovanje se koristi parent_subkey (to je id parent modula).
  //
  console.log('CODEC MAKE BUNDLE _virtelArr_to_bundleDraftel() - _virtelArr:');
  console.log(_virtelArr);
  let parent_subkey_arr = [];
  _virtelArr.forEach((item) => {
    if (parent_subkey_arr.includes(item.parent_subkey)) {
      // parent_subkey vec dodat
    } else {
      parent_subkey_arr.push(item.parent_subkey);
    }
  });
  //
  let bundle_arr = [];
  parent_subkey_arr.forEach((parent_subkey) => {
    // za svaki modul pravimo jedan _bundle_eliminatorkapi
    let _subform_arr = [];
    const bundle_id = _generate_fresh_subkey();
    _virtelArr.forEach(virtel => {
      if (virtel.parent_subkey === parent_subkey) {
        const draftel_item = {
          ...draftel_codecs_pack_terkk$_bundle_limcustom.virtel_to_subDraftel(virtel),
          tempkey: _generateFreshTempkey(),
        };
        _subform_arr.push(draftel_item);
      }
    });
    if (js_utils.is_object(_subform_arr[0])) {
      const _first_item = _subform_arr[0];
      const zajednicki_higher_props_za_items = {
        parent_subkey,
        // superkey: bundle.superkey, // ???
        // bundle_id: p.bundle_id,
        subkey: bundle_id,
        // od poluproizvoda
        //
        // pods_input TODO Da li treba bolje resenje?
        //
      };
      let bundleDraftel = {
        // _draftelschemakey: 'terkk$_bundle_eliminatorkapi',
        ...draftel_codecs_pack_terkk$_bundle_limcustom.default_preset_state(),
        _subform_arr: _subform_arr,
        ...zajednicki_higher_props_za_items
      };
      bundle_arr.push(bundleDraftel);
    }
  });
  console.log('CODEC output BUNDLES bundle_arr');
  console.log(bundle_arr);
  return bundle_arr;
};

